import createAxiosInstance from './axiosConfig';
import { expandirTaxasFidc } from '../shared/model/fidcTaxas';
import { Fidc } from '../shared/model/fidc';

const { REACT_APP_ESTEIRA_BACK } = process.env;

const axiosInstance = createAxiosInstance(REACT_APP_ESTEIRA_BACK + '/rest/fidcController');

export default class FidcService {
  axios: any;

  constructor() {
    this.axios = axiosInstance;
  }

  async reordenar(ids: (number | string | null)[], justificativa: string) { return this.axios.post('/reordenar', { ids, justificativa }); }
  async historico(id: number | string) { return this.axios.get('/historico', { params: { id } }); }
  async listarTodosFidcs() {
    return await this.axios.get(`/listarTodosFidcs`);
  };

  async listarFidcPorId(id: string) {
    return await this.axios.get(`/listarFidcPorId?id=${id}`);
  };

  async incluirAlterarFidc(dto: Fidc) {
    return await this.axios.post(`/incluirAlterarFidc`, { ...dto, elegibilidade: { ...dto.elegibilidade, taxas: expandirTaxasFidc(dto.elegibilidade) } });
  };
}